import RichTextPreview from '@/components/richText/RichTextPreview.tsx';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/Card.tsx';

interface CashInstructionInfoProps {
  cashInstruction: string;
}

const CashInstructionInfo = ({ cashInstruction }: CashInstructionInfoProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Płatność gotówką</CardTitle>
      </CardHeader>
      <CardContent>
        <RichTextPreview html={cashInstruction} />
      </CardContent>
    </Card>
  );
};

export default CashInstructionInfo;
